import { useEffect, useRef } from "react";

const hasVideo = ({ urls }) =>
  Object.values(urls).reduce((result, url) => result || !!url, false);

const getCleanMp4Url = (mp4Url) => {
  // Return null if no URL provided
  if (!mp4Url) return null;

  // Extract parts of mp4 URL using regex: path, extension, query params
  const match = mp4Url.match(/^(.*?)(\.mp4)(\?.*)?$/);

  // If URL matches expected format, insert '-clean' before extension
  if (match) {
    return `${match[1]}-clean${match[2]}${match[3] || ""}`;
  }

  // Fallback: just append '-clean' to URL
  return `${mp4Url}-clean`;
};

const Slide = ({ active, assets, muted, paused }) => {
  const videoRef = useRef();
  const photo = assets.photos.find(
    (photo) => photo.name === "standard" && photo.url
  );
  const video = assets.videos.find(
    (video) => video.name === "standard" && hasVideo(video)
  );

  useEffect(() => {
    if (active) {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
      }
    }
  }, [active]);

  useEffect(() => {
    const onPause = () => {
      try {
        if (paused && !videoRef.current.paused) {
          videoRef?.current?.pause && videoRef.current.pause()
        } else {
          videoRef?.current?.play && videoRef.current.play()
        }
      } catch {}
    }
    onPause()
  }, [paused]);

  if (video) {
    if (video.urls.gif) {
      return <img src={video.urls.gif} alt="" />;
    }

    const cleanMp4Url = getCleanMp4Url(video.urls.mp4);

    return (
      <video
        autoPlay
        muted={muted}
        playsInline
        preload="auto"
        height="100%"
        poster={video.urls.png}
        ref={videoRef}
      >
        {cleanMp4Url && <source src={cleanMp4Url} type="video/mp4" />}
        {video.urls.mp4 && <source src={video.urls.mp4} type="video/mp4" />}
        {video.urls.webm && <source src={video.urls.webm} type="video/webm" />}
      </video>
    );
  }

  return photo?.url ? <img src={photo?.url} alt="" /> : null;
};

export default Slide;
